var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWalletEnter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#232429"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 20C29 18.7574 27.9926 17.75 26.75 17.75H23C23 19.4069 21.6569 20.75 20 20.75C18.3431 20.75 17 19.4069 17 17.75H13.25C12.0074 17.75 11 18.7574 11 20M29 20V26C29 27.2426 27.9926 28.25 26.75 28.25H13.25C12.0074 28.25 11 27.2426 11 26V20M29 20V17M11 20V17M29 17C29 15.7574 27.9926 14.75 26.75 14.75H13.25C12.0074 14.75 11 15.7574 11 17M29 17V14C29 12.7574 27.9926 11.75 26.75 11.75H13.25C12.0074 11.75 11 12.7574 11 14V17",
    stroke: "#F9FAFB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWalletEnter);
export default __webpack_public_path__ + "static/media/icon_wallet_enter.29b6a57ff63eb774c1248f97c0ec3533.svg";
export { ForwardRef as ReactComponent };